// Shared response-unwrapping helper for planner stores. Backend controllers
// wrap single-resource responses as { resource } and list responses as
// { data } — mirrors the pattern already used by use-api-keys.ts.
export function unwrap<T>(res: { data: { resource?: T; data?: T } }): T {
  return (res.data.resource ?? res.data.data) as T;
}
